import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const AssignedCaseCard = ({ caseAssignment, onUpdate }) => {
  const [expanded, setExpanded] = useState(false);

  const getStatusColor = (status) => {
    switch (status) {
      case 'assigned':
        return 'bg-blue-100 text-blue-800';
      case 'in_progress':
        return 'bg-yellow-100 text-yellow-800';
      case 'completed':
        return 'bg-green-100 text-green-800';
      case 'on_hold':
        return 'bg-red-100 text-red-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  const handleStatusChange = (newStatus) => {
    onUpdate(caseAssignment?.id, { status: newStatus });
  };

  return (
    <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
      <div className="flex items-start justify-between mb-3">
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-1">
            <h3 className="font-semibold text-gray-900">Cas #{caseAssignment?.caseId?.slice(0, 8)}</h3>
            <span className={`text-xs px-2 py-1 rounded-full ${getStatusColor(caseAssignment?.status)}`}>
              {caseAssignment?.status}
            </span>
          </div>
          <p className="text-xs text-gray-500">
            Assigné le {new Date(caseAssignment?.assignedAt)?.toLocaleDateString('fr-FR')}
          </p>
        </div>
        <button
          onClick={() => setExpanded(!expanded)}
          className="text-gray-400 hover:text-gray-600 transition-colors"
        >
          <Icon name={expanded ? 'ChevronUp' : 'ChevronDown'} size={20} />
        </button>
      </div>
      {/* Machine Assignment */}
      {caseAssignment?.machine && (
        <div className="mb-3 p-2 bg-white rounded border border-gray-200">
          <div className="flex items-center gap-2">
            <Icon name="Settings" size={16} className="text-blue-600" />
            <div>
              <p className="text-sm font-medium text-gray-900">{caseAssignment?.machine?.machine_name}</p>
              <p className="text-xs text-gray-500">{caseAssignment?.machine?.machine_code}</p>
            </div>
          </div>
        </div>
      )}
      {/* Expanded Details */}
      {expanded && (
        <div className="mt-3 pt-3 border-t border-gray-200 space-y-3">
          {/* Notes */}
          {caseAssignment?.notes && (
            <div>
              <p className="text-xs font-medium text-gray-700 mb-1">Notes:</p>
              <p className="text-sm text-gray-600 bg-white p-2 rounded">{caseAssignment?.notes}</p>
            </div>
          )}

          {/* Status Actions */}
          <div>
            <p className="text-xs font-medium text-gray-700 mb-2">Changer le statut:</p>
            <div className="flex flex-wrap gap-2">
              {caseAssignment?.status !== 'in_progress' && (
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() => handleStatusChange('in_progress')}
                >
                  Démarrer
                </Button>
              )}
              {caseAssignment?.status === 'in_progress' && (
                <>
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={() => handleStatusChange('on_hold')}
                  >
                    Suspendre
                  </Button>
                  <Button
                    variant="primary"
                    size="sm"
                    onClick={() => handleStatusChange('completed')}
                  >
                    Terminer
                  </Button>
                </>
              )}
              {caseAssignment?.status === 'on_hold' && (
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() => handleStatusChange('in_progress')}
                >
                  Reprendre
                </Button>
              )}
            </div>
          </div>

          {/* Privacy Notice */}
          <div className="bg-blue-50 border border-blue-200 rounded p-2">
            <div className="flex items-start gap-2">
              <Icon name="Lock" size={16} className="text-blue-600 flex-shrink-0 mt-0.5" />
              <p className="text-xs text-blue-800">
                Les informations patient sont anonymisées pour la confidentialité
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AssignedCaseCard;